/* eslint-disable */
import React, { useState, useEffect } from "react";
import ImageUploading from "react-images-uploading";
import { ModalImage, ImageCard } from "./ImageComponents";
import { useLocation } from "react-router-dom";
import { errorPopup } from "@/helpers";
import { useFormContext } from "react-hook-form";
import { MdQuestionMark } from "react-icons/md";
import Swal from "sweetalert2";

export const ImagesForm = () => {
  const location = useLocation();
  const { listId = "" } = location.state || {};
  const maxNumber = 70;

  const { setValue, watch, errors } = useFormContext();
  const images = watch("images") || [];
  const imgdescription = watch("imgdescription") || [];
  const deletedImages = watch("deleted_images") || [];
  const [featuredIndex, setFeaturedIndex] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    // This effect ensures that the featured index is correctly set when images are loaded.
    const featuredImageIndex = images.findIndex((img) => img.sort_order === 0);
    setFeaturedIndex(featuredImageIndex !== -1 ? featuredImageIndex : null);
  }, [images]);

  const onChange = (imageList) => {
    setValue("images", imageList);
  };

  const moveImage = (fromIndex, toIndex) => {
    const updatedImages = [...images];
    const [movedImage] = updatedImages.splice(fromIndex, 1);
    updatedImages.splice(toIndex, 0, movedImage);
    setValue("images", updatedImages);
    setFeaturedIndex(toIndex);

    if (imgdescription && Array.isArray(imgdescription)) {
      const updatedDescriptions = [...imgdescription];
      const [movedDescription] =
        updatedDescriptions.length > fromIndex
          ? updatedDescriptions.splice(fromIndex, 1)
          : [undefined];

      if (movedDescription !== undefined) {
        updatedDescriptions.splice(toIndex, 0, movedDescription);
      } else if (toIndex <= updatedDescriptions.length) {
        updatedDescriptions.splice(toIndex, 0, "");
      }
      setValue("imgdescription", updatedDescriptions);
    }
  };

  const handleDelete = (index, id) => {
    if (listId && id) {
      setValue("deleted_images", [...deletedImages, id]);
    }
    const updatedImages = images?.filter((_, i) => i !== index);
    setValue("images", updatedImages);
  };

  const handleStarClick = (index) => {
    if (index === 0) return;
    moveImage(index, 0);
  };

  const handleDescriptionClick = (image, index) => {
    setSelectedImage({ ...image, index });
    setDescription(image.description || "");
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
  };

  const saveDescription = () => {
    if (selectedImage) {
      const updatedImages = [...images];
      updatedImages[selectedImage.index] = {
        ...updatedImages[selectedImage.index],
        description: description,
      };
      setValue("images", updatedImages);

      if (!Array.isArray(imgdescription)) {
        setValue("imgdescription", []);
        return;
      }

      const updatedDescriptions = [...imgdescription];
      while (updatedDescriptions.length <= selectedImage.index) {
        updatedDescriptions.push("");
      }

      updatedDescriptions[selectedImage.index] = description;

      if (updatedDescriptions.length > imgdescription.length + 1) {
        throw new Error("Array length mismatch during update");
      }

      setValue("imgdescription", updatedDescriptions);
    }
    closeModal();
  };

  // Transformation logic: Convert the API data format to the expected format for react-images-uploading.
  // The library expects an array of objects, where each object has a 'data_url' key for the image source.
  const transformedImages = images.map((image) => ({
    ...image,
    data_url: image.file, // Use the existing `file` key which already contains the URL
  }));

  return (
    <>
      <div className="p-4 bg-white col-md-12">
        <h2 className="mb-4 text-2xl font-bold text-center justify-center flex items-center gap-1">
          <span>Media</span>

          <MdQuestionMark
            onClick={() =>
              Swal.fire({
                text: "Click inside the box to select the photos you want to use in your listing. For best results, your first five photos should be a landscape (horizontal) orientation. Once you have uploaded your photos, you can drag and drop them to customize the order in the gallery. You can use the pencil icon to write a brief description of each photo.",
                icon: "question",
              })
            }
            style={{
              color: "#fff",
              background: "#8ec639",
              borderRadius: "50%",
              fontWeight: "bold",
              fontSize: "1.2rem",
              marginLeft: "8px",
              boxShadow: "0 0 8px 2px #8ec639, 0 0 0 3px #c6f6d5",
              border: "2px solid #8ec639",
              cursor: "pointer",
              padding: "2px",
              animation: "pulse-glow 1.2s infinite alternate",
            }}
            className="focus:outline-none focus:ring-2 focus:ring-[#8ec639]"
            title="Click inside the box to select the photos you want to use in your listing. For best results, your first five photos should be a landscape (horizontal) orientation. Once you have uploaded your photos, you can drag and drop them to customize the order in the gallery. You can use the pencil icon to write a brief description of each photo."
          />
        </h2>
        <ImageUploading
          multiple
          value={transformedImages} // Use the transformed data here
          onChange={onChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
          acceptType={["jpg", "jpeg", "png", "webp"]}
          beforeUpload={(files) => {
            const validTypes = [
              "image/jpeg",
              "image/jpg",
              "image/png",
              "image/webp",
            ];
            const invalidFiles = files.filter(
              (file) => !validTypes.includes(file.type)
            );
            if (invalidFiles.length > 0) {
              errorPopup("", `Only JPG, PNG, and WEBP images are allowed.`);
              return false;
            }
            const maxSize = 5 * 1024 * 1024;
            const tooLargeFiles = files.filter((file) => file.size > maxSize);
            if (tooLargeFiles.length > 0) {
              errorPopup("", `Files must be smaller than 5MB`);
              return false;
            }
            return true;
          }}
        >
          {({ imageList, onImageUpload, isDragging, dragProps }) => (
            <div className="upload__image-wrapper">
              <div
                className="fu-text"
                style={isDragging ? { color: "red" } : null}
                onClick={onImageUpload}
                {...dragProps}
              >
                <div className="add-list-media-wrap">
                  <div className="listsearch-input-item fl-wrap">
                    <div className="fuzone">
                      <div className="fu-text">
                        <span>
                          <i className="fal fa-images" /> PLEASE BE PATIENT
                          WHILE YOUR PHOTOS UPLOAD :)
                          <br />
                          Drag and drop the images to customize the gallery
                          order.
                          <br />
                          Click on the star icon to set the featured image.
                          <br />
                          <span>(Minimum size 1440 x 900 px)</span>
                        </span>
                        <div className="photoUpload-files fl-wrap" />
                        <div className="!text-center pt-[27px]">
                          <span className="custom_image_button">
                            Select and upload
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="photoUpload-files fl-wrap" />
              </div>

              <div
                className="row"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-start",
                }}
              >
                {imageList?.map((image, index) => (
                  <ImageCard
                    key={index}
                    image={image}
                    index={index}
                    moveImage={moveImage}
                    onDelete={handleDelete}
                    isFeatured={index === featuredIndex}
                    onStarClick={handleStarClick}
                    description={description}
                    onDescriptionClick={handleDescriptionClick}
                  />
                ))}
              </div>
            </div>
          )}
        </ImageUploading>

        {isModalOpen && (
          <ModalImage
            saveDescription={saveDescription}
            closeModal={closeModal}
            selectedImage={selectedImage}
            description={description}
            isModalOpen={isModalOpen}
            setDescription={setDescription}
          />
        )}

        {errors?.images && (
          <p className="mt-1 text-red-500">{errors?.images?.message}</p>
        )}
      </div>
    </>
  );
};
